import React, { createContext, useContext, useMemo, useState } from 'react';

import { SelectedFavouriteBrandContext as Context } from './types';

const SelectedFavouriteBrandContext = createContext({} as Context);
export const useSelectedFavouriteBrandContext = () => useContext(SelectedFavouriteBrandContext);

interface Props {
  children: React.ReactNode;
}

export const SelectedFavouriteBrandProvider = (props: Props) => {
  const [ selectedFavouriteBrand, setSelectedFavouriteBrand ] = useState<Context['selectedFavouriteBrand']>();

  const value = useMemo(() => ({
    selectedFavouriteBrand,
    setSelectedFavouriteBrand
  }), [
    selectedFavouriteBrand,
    setSelectedFavouriteBrand
  ]);

  return (
    <SelectedFavouriteBrandContext.Provider value={value}>{props.children}</SelectedFavouriteBrandContext.Provider>
  );
};
